import { Avatar, AvatarFallback } from "ui/components/avatar";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "ui/components/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";

import { Button } from "ui";
import { CIRCLE_CHECK, UP_RIGHT } from "icons";
import { COMMON_CLASSES_FOR_CARD } from "./utils";
import Icon from "../../icon";
import { Link } from "react-router-dom";
import { RenderAvatar } from "../../render-avatar";
import { cn } from "utils";
import { formatName } from "utils";
import { TagBadge } from "components/badge/timesheet-tags";

export default function EntryCard({
  entry,
  href,
  isReview = false,
  canReview = false,
  className,
  handleReviewClick,
  onClick,
  ...props
}) {
  if (!entry) {
    return null;
  }
  const isReviewed =
    (entry.approved_hours ?? 0) || (entry.unapproved_hours ?? 0);

  return (
    <Link
      to={href}
      className={cn(className, "cursor-pointer col-span-1")}
      onClick={onClick}
      {...props}
    >
      <Card
        className={cn(
          COMMON_CLASSES_FOR_CARD,
          "h-full",
          isReviewed && "bg-accent",
          className,
        )}
      >
        <CardHeader>
          <div className="flex justify-between">
            <div className="flex-1 flex flex-col whitespace-nowrap gap-1">
              <Tooltip>
                <TooltipTrigger className="text-left w-max max-w-full">
                  <CardTitle className="max-w-48">
                    <div className="flex items-center gap-2">
                      <span className="truncate">{entry.project?.name}</span>
                      {entry.tag && (
                        <div className="shrink-0">
                          <TagBadge tag={entry.tag} />
                        </div>
                      )}
                    </div>
                  </CardTitle>
                </TooltipTrigger>
                <TooltipContent>{entry.project?.name}</TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger className="text-left w-max">
                  <CardDescription className="truncate max-w-60">
                    {entry.job?.name}
                  </CardDescription>
                </TooltipTrigger>
                <TooltipContent>{entry.job?.name}</TooltipContent>
              </Tooltip>
            </div>
            <div className="font-medium ">
              {isReviewed ? (
                <div className="space-x-1">
                  <Tooltip className="!bg-white">
                    <TooltipTrigger className="text-base-foreground">
                      {entry.approved_hours}hr
                    </TooltipTrigger>
                    <TooltipContent>Approved</TooltipContent>
                  </Tooltip>

                  <Tooltip>
                    <TooltipTrigger className="text-muted-foreground">
                      {entry.unapproved_hours ?? 0}hr
                    </TooltipTrigger>
                    <TooltipContent>Unapproved</TooltipContent>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip className="!bg-white">
                  <TooltipTrigger className="">
                    {entry.logged_hours ?? 0}hr
                  </TooltipTrigger>
                  <TooltipContent>Logged</TooltipContent>
                </Tooltip>
              )}
            </div>
          </div>
        </CardHeader>
        <CardContent className="-mt-2 flex-1">
          {entry.milestone?.name && (
            <h3 className="text-sm">{entry.milestone?.name}</h3>
          )}
          {entry.description && (
            <p className="text-xs whitespace-pre-wrap font-normal line-clamp-3 text-muted-foreground">
              {entry.description}
            </p>
          )}
        </CardContent>
        {isReview && (
          <CardFooter className="flex justify-between">
            <div className="flex gap-2 items-center">
              <Avatar className="h-8 w-8 rounded-full">
                <RenderAvatar
                  user={entry.employee}
                  alt={entry.employee.first_name}
                />
              </Avatar>{" "}
              <span className="font-medium text-xs">
                {formatName(entry.employee)}
              </span>
            </div>
            <div className="flex gap-2">
              {canReview
                ? ""
                : //   (
                  //   <Button
                  //     variant="ghost"
                  //     onClick={(e) => {
                  //       e.preventDefault();
                  //       e.stopPropagation();
                  //       if (href) window.location.href = href;
                  //     }}
                  //   >
                  //     <Icon icon={UP_RIGHT} />
                  //   </Button>
                  // )
                  !isReviewed && (
                    <Button
                      variant="ghost"
                      onClick={(e) => {
                        e.preventDefault();
                        handleReviewClick?.(e);
                      }}
                    >
                      <Icon icon={CIRCLE_CHECK} />
                    </Button>
                  )}
            </div>
          </CardFooter>
        )}
      </Card>
    </Link>
  );
}
